import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["search", "row", "area", "count", "changedCount", "queryMessage"]

  connect() {
    this.activeArea = "all"
    this.refresh()
  }

  refresh() {
    let allowed = 0
    let changed = 0

    this.rowTargets.forEach((row) => {
      const selected = row.querySelector("input[type='radio']:checked")?.value || ""
      const base = row.dataset.baseScope || ""
      const baseLabel = row.dataset.baseLabel || (base ? this.humanize(base) : "")
      const isChanged = selected !== base
      const changeLabel = row.querySelector("[data-change-label]")

      if (selected) allowed += 1
      if (isChanged) changed += 1
      row.classList.toggle("is-changed", isChanged)
      if (changeLabel) {
        changeLabel.hidden = !isChanged
        changeLabel.textContent = baseLabel ? `Changed from ${baseLabel}` : "New permission"
      }
    })

    this.countTarget.textContent = allowed
    this.changedCountTarget.textContent = changed
    this.filter()
  }

  filter() {
    const query = this.hasSearchTarget ? this.searchTarget.value.trim().toLowerCase() : ""
    let visibleRows = 0

    this.rowTargets.forEach((row) => {
      const areaMatches = this.activeArea === "all" || row.dataset.area === this.activeArea
      const queryMatches = !query || row.dataset.search.includes(query)
      row.hidden = !(areaMatches && queryMatches)
      if (!row.hidden) visibleRows += 1
    })

    this.areaTargets.forEach((area) => {
      const hasVisibleRows = [...area.querySelectorAll("[data-dwm-permission-matrix-target='row']")].some((row) => !row.hidden)
      area.hidden = !hasVisibleRows
    })
    this.queryMessageTarget.hidden = visibleRows > 0
  }

  selectArea(event) {
    this.activeArea = event.currentTarget.dataset.area
    event.currentTarget.closest("nav").querySelectorAll("button").forEach((button) => {
      button.classList.toggle("is-active", button === event.currentTarget)
    })
    this.filter()
  }

  humanize(value) {
    return value.replaceAll("_", " ").replace(/^./, (character) => character.toUpperCase())
  }
}
